/* eslint-disable no-plusplus */
/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
import { PublicClientApplication } from '@azure/msal-browser';
// import { InteractionRequiredAuthError } from '@azure/msal-common';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import XLSX from 'xlsx';

import { msalConfig } from '../config/app-config';
import { USER_LOGOUT } from './types';

const msalInstance = new PublicClientApplication(msalConfig);

const ct = require('countries-and-timezones');
const cc = require('currency-codes');

export const isResponseValid = resp => {
  return resp && (resp.status === 200 || resp.status === 201);
};

export const isAllResponseValid = resp => {
  return resp && resp.every(r => r.status === 200 || r.status === 201);
};

export const formatAmount = (l, p, c) => {
  try {
    if (Number.isNaN(p)) {
      throw new Error('Not A Number');
    }
    if (p === undefined) {
      return '_';
    }
    return `${new Intl.NumberFormat(l, {
      // style: 'currency',
      currency: c,
      minimumFractionDigits: 2,
    }).format(p)} ${c !== undefined ? c : ''}`;
  } catch (err) {
    if (err.message === 'Not A Number') {
      return `0 ${c !== undefined ? c : ''}`;
    }
    return '_';
  }
};
export const formatAmountNew = (l, p, c) => {
  try {
    if (Number.isNaN(p)) {
      throw new Error('Not A Number');
    }
    return new Intl.NumberFormat(l, {
      style: 'currency',
      currency: c,
    }).format(p);
  } catch {
    return `0 ${c}`;
  }
};
export function SAPException(details) {
  this.details = details;
  this.name = 'PB2BSAPException';
}
export const throwSAPError = error => {
  throw new SAPException(error);
};
export function CustomException(message) {
  this.message = message;
  this.name = 'PB2BCustomException';
}

export const genPickerData = ({ data, config }) => {
  return data.map(d => {
    return {
      ...d,
      id: config.idFunc(d),
      label: config.labelFunc(d),
      value: config.valueFunc(d),
      checked: false,
    };
  });
};

export const getCountryData = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return ct.getCountryForTimezone(timezone);
  } catch (err) {
    console.log(err);
  }
  return '';
};

export const getCurrencyData = countryData => {
  try {
    return cc.data.filter(c => {
      return c.countries.some(s => s.toUpperCase().includes(countryData.name.toUpperCase()));
    });
  } catch (err) {
    console.log(err);
  }
  return '';
};

export const getLanguage = () => {
  try {
    return navigator.language.split('-');
  } catch (err) {
    console.log(err);
  }
  return [];
};

export const getListItemsCount = async (config, url) => {
  const countService = axios.create({
    baseURL: url,
  });

  const countResponse = await countService.get('/$count', config).catch(e => {
    throwSAPError(e);
    return null;
  });
  if (isResponseValid(countResponse)) {
    return countResponse.data;
  }
  return null;
};

const isTokenExpired = token => {
  const decodedToken = jwt_decode(token);
  const current_time = new Date().getTime() / 1000;
  if (current_time > decodedToken.exp) {
    return true;
  }
  return false;
};

export const getIdToken = async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { idToken } = auth;
    if (idToken) {
      if (isTokenExpired(idToken)) {
        await msalInstance.logoutPopup();
        dispatch({
          type: USER_LOGOUT,
        });
      }
    }
    return idToken;
  } catch (e) {
    await msalInstance.logoutPopup();
    dispatch({
      type: USER_LOGOUT,
    });

    return null;
  }
};

export const getAvatarText = name => {
  try {
    if (name === '' || name === undefined) {
      return '';
    }
    const strList = name.split(' ');

    return strList[0][0] + strList[1][0];
  } catch (err) {
    console.log(err);
    return name;
  }
};

export const returnCountArr = n => {
  const count = [];
  for (let i = 0; i < n; i++) {
    count.push(i);
  }
  return count;
};

function saveExcelFile(buffer, fileName) {
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}

export const downloadExcel = (Data, fName, sheetName) => {
  const ws = XLSX.utils.json_to_sheet(Data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveExcelFile(excelBuffer, fName);
};

export const formatedText = (text = '-', length = 13) => {
  let fText = text;
  if (text.length > length) {
    fText = `${text.substring(0, length)}...`;
  }
  return fText;
};

export const roundToTwoDecimals = number => {
  return Number(Number(number).toFixed(2));
};
